import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AddBoxIcon from '@mui/icons-material/AddBox';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddIcon from '@mui/icons-material/Add';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckIcon from '@mui/icons-material/Check';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import ContactsIcon from '@mui/icons-material/Contacts';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DeleteIcon from '@mui/icons-material/Delete';
import DescriptionIcon from '@mui/icons-material/Description';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import DoneIcon from '@mui/icons-material/Done';
import DomainIcon from '@mui/icons-material/Domain';
import DownloadIcon from '@mui/icons-material/Download';
import DnsIcon from '@mui/icons-material/Dns';
import EmailIcon from '@mui/icons-material/Email';
import EmergencyIcon from '@mui/icons-material/Emergency';
import ErrorIcon from '@mui/icons-material/Error';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import FaxIcon from '@mui/icons-material/Fax';
import FilterListIcon from '@mui/icons-material/FilterList';
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid';
import FolderIcon from '@mui/icons-material/Folder';
import ForumIcon from '@mui/icons-material/Forum';
import HandshakeIcon from '@mui/icons-material/Handshake';
import InfoIcon from '@mui/icons-material/Info';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LogoutIcon from '@mui/icons-material/Logout';
import MapIcon from '@mui/icons-material/Map';
import MenuIcon from '@mui/icons-material/Menu';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import NfcIcon from '@mui/icons-material/Nfc';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import NotificationsIcon from '@mui/icons-material/Notifications';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PaymentsIcon from '@mui/icons-material/Payments';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import PlaceIcon from '@mui/icons-material/Place';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RemoveIcon from '@mui/icons-material/Remove';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import StarIcon from '@mui/icons-material/Star';
import TodayIcon from '@mui/icons-material/Today';
import TransitEnterexitIcon from '@mui/icons-material/TransitEnterexit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {
  AccessTimeOutlined,
  AddBoxOutlined,
  AddCircleOutlined,
  AddOutlined,
  ApartmentOutlined,
  ArrowBackIosNewOutlined,
  ArrowBackIosOutlined,
  ArrowForwardOutlined,
  ArrowRightOutlined,
  AttachFileOutlined,
  BusinessCenterOutlined,
  CalendarMonthOutlined,
  CalendarTodayOutlined,
  CameraAltOutlined,
  CancelOutlined,
  ChangeHistoryOutlined,
  CheckCircleOutline as CheckCircleOutlineOutlined,
  CheckCircleOutlined,
  CheckOutlined,
  ChevronLeftOutlined,
  ChevronRightOutlined,
  CloseOutlined,
  ContactsOutlined,
  ContentCopyOutlined,
  DeleteForeverOutlined,
  DeleteOutlined,
  DescriptionOutlined,
  DisabledByDefaultOutlined,
  DoneOutlined,
  DomainOutlined,
  DownloadOutlined,
  DnsOutlined,
  EmailOutlined,
  EmergencyOutlined,
  ErrorOutline as ErrorOutlineOutlined,
  ErrorOutlined,
  EventAvailableOutlined,
  FaxOutlined,
  FilterListOutlined,
  FlipCameraAndroidOutlined,
  FolderOutlined,
  ForumOutlined,
  HandshakeOutlined,
  InfoOutlined,
  KeyboardArrowDownOutlined,
  LabelImportantOutlined,
  LightbulbOutlined,
  LocationOnOutlined,
  LogoutOutlined,
  MapOutlined,
  MenuOutlined,
  MoreHorizOutlined,
  NfcOutlined,
  NightsStayOutlined,
  NotificationsOutlined,
  OpenInNewOutlined,
  PaymentsOutlined,
  PeopleAltOutlined,
  PersonAddOutlined,
  PersonOutlined,
  PhoneOutlined,
  PlaceOutlined,
  RemoveCircleOutlined,
  RemoveOutlined,
  ScheduleOutlined,
  SearchOutlined,
  SettingsOutlined,
  ShoppingCartOutlined,
  SmartphoneOutlined,
  StarOutlined,
  TodayOutlined,
  TransitEnterexitOutlined,
  VisibilityOutlined,
  WarningAmberOutlined,
  WbSunnyOutlined,
  ZoomOutMapOutlined,
  FiberManualRecordOutlined
} from '@mui/icons-material';

export const IconsList = {
  access_time: AccessTimeIcon,
  add: AddIcon,
  add_box: AddBoxIcon,
  add_circle: AddCircleIcon,
  apartment: ApartmentIcon,
  arrow_back_ios: ArrowBackIosIcon,
  arrow_back_ios_new: ArrowBackIosNewIcon,
  arrow_forward: ArrowForwardIcon,
  arrow_right: ArrowRightIcon,
  attach_file: AttachFileIcon,
  business_center: BusinessCenterIcon,
  calendar_month: CalendarMonthIcon,
  calendar_today: CalendarTodayIcon,
  camera_alt: CameraAltIcon,
  cancel: CancelIcon,
  change_history: ChangeHistoryIcon,
  check: CheckIcon,
  check_box: CheckBoxIcon,
  check_box_outline_blank: CheckBoxOutlineBlankIcon,
  check_circle: CheckCircleIcon,
  check_circle_outline: CheckCircleOutlineIcon,
  chevron_left: ChevronLeftIcon,
  chevron_right: ChevronRightIcon,
  close: CloseIcon,
  contacts: ContactsIcon,
  content_copy: ContentCopyIcon,
  delete: DeleteIcon,
  delete_forever: DeleteForeverIcon,
  description: DescriptionIcon,
  disabled_by_default: DisabledByDefaultIcon,
  dns: DnsIcon,
  done: DoneIcon,
  domain: DomainIcon,
  download: DownloadIcon,
  email: EmailIcon,
  emergency: EmergencyIcon,
  error: ErrorIcon,
  error_outline: ErrorOutlineIcon,
  event_available: EventAvailableIcon,
  fax: FaxIcon,
  fiber_manual_record: FiberManualRecordIcon,
  filter_list: FilterListIcon,
  flip_camera_android: FlipCameraAndroidIcon,
  folder: FolderIcon,
  forum: ForumIcon,
  handshake: HandshakeIcon,
  info: InfoIcon,
  keyboard_arrow_down: KeyboardArrowDownIcon,
  label_important: LabelImportantIcon,
  lightbulb: LightbulbIcon,
  location_on: LocationOnIcon,
  logout: LogoutIcon,
  map: MapIcon,
  menu: MenuIcon,
  more_horiz: MoreHorizIcon,
  nfc: NfcIcon,
  nights_stay: NightsStayIcon,
  notifications: NotificationsIcon,
  open_in_new: OpenInNewIcon,
  payments: PaymentsIcon,
  people_alt: PeopleAltIcon,
  person: PersonIcon,
  person_add: PersonAddIcon,
  phone: PhoneIcon,
  place: PlaceIcon,
  remove: RemoveIcon,
  remove_circle: RemoveCircleIcon,
  schedule: ScheduleIcon,
  search: SearchIcon,
  settings: SettingsIcon,
  shopping_cart: ShoppingCartIcon,
  smartphone: SmartphoneIcon,
  star: StarIcon,
  today: TodayIcon,
  transit_enterexit: TransitEnterexitIcon,
  visibility: VisibilityIcon,
  warning_amber: WarningAmberIcon,
  wb_sunny: WbSunnyIcon,
  zoom_out_map: ZoomOutMapIcon,

  // Outlined Icons list
  access_time_outlined: AccessTimeOutlined,
  add_box_outlined: AddBoxOutlined,
  add_circle_outlined: AddCircleOutlined,
  add_outlined: AddOutlined,
  apartment_outlined: ApartmentOutlined,
  arrow_back_ios_new_outlined: ArrowBackIosNewOutlined,
  arrow_back_ios_outlined: ArrowBackIosOutlined,
  arrow_forward_outlined: ArrowForwardOutlined,
  arrow_right_outlined: ArrowRightOutlined,
  attach_file_outlined: AttachFileOutlined,
  business_center_outlined: BusinessCenterOutlined,
  calendar_month_outlined: CalendarMonthOutlined,
  calendar_today_outlined: CalendarTodayOutlined,
  camera_alt_outlined: CameraAltOutlined,
  cancel_outlined: CancelOutlined,
  change_history_outlined: ChangeHistoryOutlined,
  check_box_blank_outline: CheckBoxOutlineBlankOutlinedIcon,
  check_box_outlined: CheckBoxOutlinedIcon,
  check_circle_outline_outlined: CheckCircleOutlineOutlined,
  check_circle_outlined: CheckCircleOutlined,
  check_outlined: CheckOutlined,
  chevron_left_outlined: ChevronLeftOutlined,
  chevron_right_outlined: ChevronRightOutlined,
  close_outlined: CloseOutlined,
  contacts_outlined: ContactsOutlined,
  content_copy_outlined: ContentCopyOutlined,
  delete_forever_outlined: DeleteForeverOutlined,
  delete_outlined: DeleteOutlined,
  description_outlined: DescriptionOutlined,
  disabled_by_default_outlined: DisabledByDefaultOutlined,
  dns_outlined: DnsOutlined,
  done_outlined: DoneOutlined,
  domain_outlined: DomainOutlined,
  download_outlined: DownloadOutlined,
  email_outlined: EmailOutlined,
  emergency_outlined: EmergencyOutlined,
  error_outline_outlined: ErrorOutlineOutlined,
  error_outlined: ErrorOutlined,
  event_available_outlined: EventAvailableOutlined,
  fax_outlined: FaxOutlined,
  fiber_manual_record_outlined: FiberManualRecordOutlined,
  filter_list_outlined: FilterListOutlined,
  flip_camera_android_outlined: FlipCameraAndroidOutlined,
  folder_outlined: FolderOutlined,
  forum_outlined: ForumOutlined,
  handshake_outlined: HandshakeOutlined,
  info_outlined: InfoOutlined,
  keyboard_arrow_down_outlined: KeyboardArrowDownOutlined,
  label_important_outlined: LabelImportantOutlined,
  lightbulb_outlined: LightbulbOutlined,
  location_on_outlined: LocationOnOutlined,
  logout_outlined: LogoutOutlined,
  map_outlined: MapOutlined,
  menu_outlined: MenuOutlined,
  more_horiz_outlined: MoreHorizOutlined,
  nfc_outlined: NfcOutlined,
  nights_stay_outlined: NightsStayOutlined,
  notifications_outlined: NotificationsOutlined,
  open_in_new_outlined: OpenInNewOutlined,
  payments_outlined: PaymentsOutlined,
  people_alt_outlined: PeopleAltOutlined,
  person_add_outlined: PersonAddOutlined,
  person_outlined: PersonOutlined,
  phone_outlined: PhoneOutlined,
  place_outlined: PlaceOutlined,
  remove_circle_outlined: RemoveCircleOutlined,
  remove_outlined: RemoveOutlined,
  schedule_outlined: ScheduleOutlined,
  search_outlined: SearchOutlined,
  settings_outlined: SettingsOutlined,
  shopping_cart_outlined: ShoppingCartOutlined,
  smartphone_outlined: SmartphoneOutlined,
  star_outlined: StarOutlined,
  today_outlined: TodayOutlined,
  transit_enterexit_outlined: TransitEnterexitOutlined,
  visibility_outlined: VisibilityOutlined,
  warning_amber_outlined: WarningAmberOutlined,
  wb_sunny_outlined: WbSunnyOutlined,
  zoom_out_map_outlined: ZoomOutMapOutlined
};
